/**
 * Переключатели, которые нужны, чтобы откатить фичу без правки кода фичи.
 *
 * PARTICLES_ENABLED — живое кольцо из частиц на вехе серии (21.09.2026).
 * Слава: «давай пробовать, но если не понравится с частицами, откатим назад».
 * `false` → кольцо не рисуется, на его месте прежняя подача: крупная иконка
 * достижения. Остальной экран, тексты и шеринг не меняются.
 */
export const PARTICLES_ENABLED = true;

/**
 * ONBOARDING_MOLECULE_ENABLED — заставка онбординга с молекулой дофамина
 * из частиц (21.09.2026). Флаг ОТДЕЛЬНЫЙ от кольца серии: откатить одно,
 * не трогая другое. `false` → онбординг сразу открывается чатом, как раньше.
 */
export const ONBOARDING_MOLECULE_ENABLED = true;
